export const getTreatmentNameWithDuration = (treatmentName: string, treamentMinDuration: number | undefined) => {
  if (treatmentName) {
    if (treamentMinDuration) {
      return `${treatmentName} (${treamentMinDuration} min)`
    } else {
      return treatmentName
    }
  }
  return ''
}
